import { useCallback } from 'react';
import { useMainStackNavigation } from 'utils/types/navigationV6';
const useV3MicroModal = () => {
    const navigation = useMainStackNavigation();
    return useCallback((tier, benefitId) => navigation.navigate('EmmaProModal', {
        tier,
        benefitId,
        isMicroModal: true,
        skipTrialScreen: false,
    }), []);
};
export default useV3MicroModal;
